import { PrintType } from '@/types';
import { Sticker } from '@/model/printType/printTypes';

export function getIsDieCutStickerPrintType(printType: PrintType) {
  return printType.id === Sticker;
}
